import * as React from 'react';
import { useSelector } from 'react-redux';
import { getLocale, getUserProfile } from '@topconagriculture/profiling';
import { useGeoJSONListQuery } from '../../../api/fields/useGeoJSONListQuery';
import { useMarkersQuery } from '../../../api/vehicle/useMarkersQuery';
import { useDashboardConfig } from '../../../hooks/useDashboardContext';
import Map from './Map';
const MapWidget = () => {
    const user = useSelector(getUserProfile);
    const locale = useSelector(getLocale);
    const { GOOGLE_MAP_API_KEY } = useDashboardConfig();
    const { data: markerList } = useMarkersQuery();
    const { data: geoJSONList } = useGeoJSONListQuery();
    const mapConfig = {
        clusterMarkersOptions: {
            spiderfyOnMaxZoom: false,
            disableClusteringAtZoom: 16,
        },
        options: {
            maxZoom: 21,
            minZoom: 3,
            zoomControl: false,
            attributionControl: false,
            scrollWheelZoom: 'center',
            worldCopyJump: true,
        },
        tile: {
            updateInterval: 5000,
            keepBuffer: 4,
        },
        plugins: {
            search: {
                token: GOOGLE_MAP_API_KEY,
            },
            switchLayer: {
                street: 'ROADMAP',
                satellite: 'SATELLITE',
            },
        },
    };
    const mapProps = {
        clusterMarkers: true,
        clusterMarkersOptions: mapConfig.clusterMarkersOptions,
        mapOptions: mapConfig.options,
        pluginsOptions: mapConfig.plugins,
        editMode: false,
        showCursorCoordinates: true,
        locale,
        user,
        geoJSONList,
        markerList,
    };
    return React.createElement(Map, { ...mapProps });
};
export default MapWidget;
//# sourceMappingURL=MapWidget.js.map